/** @format */
import angular from 'angular';
import _ from 'lodash';
import { graduationModelModule } from '../model/graduation.model';

export const commonGraduationServiceModule = 'sis-components.service.graduationService';

(function () {
    angular.module(commonGraduationServiceModule, [graduationModelModule]).service('commonGraduationService', [
        '$http',
        'graduationEndpoint',
        'graduationJSDataModel',
        function ($http, graduationEndpoint, graduationJSDataModel) {
            // If graduation does not exist, then backend responds with empty response and here it is empty string.
            const injectGraduationIfPossible = grad => (_.isEmpty(grad) ? undefined : graduationJSDataModel.inject(grad));
            return {
                /**
                 * includes draft object
                 */
                findByAttainmentId: function (attainmentId) {
                    return $http
                        .get(`${graduationEndpoint.FOR_ATTAINMENT}/${attainmentId}`)
                        .then(response => response.data)
                        .then(injectGraduationIfPossible);
                },
            };
        },
    ]);
})();
